module.exports = __webpack_public_path__ + "logo-miraflores.png?cff0a8c460e3722444026239b9e6687d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-miraflores.png
// module id = 638
// module chunks = 0 1 2 3 7 8 9 10